import 'babel-polyfill' // polyfill promises and other ES6 features
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import filters from './filters'
import 'bootstrap/less/bootstrap.less'
import './foundations.css'
import './globalstyles.less'
import 'font-awesome/css/font-awesome.css'
import InstantSearch from 'vue-instantsearch'
import {useAirbrake} from './airbrake'
import { initSentry } from './sentry';


import {
  Dropdown,
  Collapse,
  Alert,
  Typeahead,
  DatePicker,
  Tabs,
  Tab,
  scrollspy
} from 'uiv'
import A11yModal from '@/components/A11yModal'
import A11yPopover from '@/components/A11yPopover'
import A11yTooltip from '@/components/A11yTooltip'

// start analytics tracking and fetch user info
store
  .dispatch('initTracking')
  .then(() => {
    return store.dispatch('user/getUserInfo')
  })
  .then(data => {
    if (store.getters['user/isSuperAdmin']) {
      store.commit('visibility/toggleEditorMode', true)
    }
    if (store.getters['user/isTestUser']) {
      store.commit('visibility/toggleBetaMode', true)
    }
    if (data && data.diagnostics) {
      // wrap this inside a try/catch so exceptions don't disrupt the flow of execution for the app
      try {
        document.getElementById('ci-build-info').innerHTML = `build ${data.diagnostics.build}, ${data.diagnostics.sha1}`
        console.info(data.diagnostics)
        store.commit('user/setDiagnostics', data.diagnostics)
      } catch {
        // do nothing
      }
    }
  })

// define global filters
Object.keys(filters).forEach(filter => {
  Vue.filter(filter, filters[filter])
})

Vue.component('modal', A11yModal)
Vue.component('dropdown', Dropdown)
Vue.component('popover', A11yPopover)
Vue.component('collapse', Collapse)
Vue.component('tooltip', A11yTooltip)
Vue.component('alert', Alert)
Vue.component('typeahead', Typeahead)
Vue.component('datepicker', DatePicker)
Vue.component('tabs', Tabs)
Vue.component('tab', Tab)
Vue.directive('scrollspy', scrollspy)

import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

import vStickybits from '@/util/stickybits.directive'
Vue.directive('stickybits', vStickybits)

import vueSmoothScroll from '@/util/vue-smooth-scroll.directive'
Vue.use(vueSmoothScroll)

import { sendEvent, GbAnalyticsPlugin } from '@/tracking'
import { initGa4 } from '@/tracking/ga.js'
Vue.use(GbAnalyticsPlugin)

Vue.use(InstantSearch)

Vue.config.productionTip = false

const routerWithAirbrake = useAirbrake(router)

initSentry(Vue)

import { setupHandleRequest } from './api/request_handler'
import { showLoginModal } from './router/showLoginModal'

setupHandleRequest(showLoginModal)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: routerWithAirbrake,
  store,
  render: h => h(App)
})
window.__VUE_APP_MOUNTED__ = true

// Initialize Google Analytics after Vue mounts to prevent GTM from blocking app initialization
initGa4()